interface SectionHeadingProps {
  eyebrow: string
  title: string
  desc: string
  actionLabel?: string
  actionHref?: string
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 border-b border-background-200/80 pb-5 md:mb-8 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="mb-2 flex items-center gap-2">
          <span className="h-4 w-[3px] rounded-full bg-primary-500"></span>
          <span className="font-label text-xs font-medium uppercase tracking-[0.18em] text-primary-700">
            {eyebrow}
          </span>
        </div>
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[30px]">{title}</h2>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{desc}</p>
      </div>
      {actionLabel && actionHref && (
        <a
          href={actionHref}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-background-300/80 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-secondary-400 hover:bg-secondary-50 hover:text-secondary-800 cursor-pointer"
        >
          {actionLabel}
          <i className="ri-arrow-right-line text-base"></i>
        </a>
      )}
    </div>
  )
}